import Icons from 'assets/icons';

interface InvalidChartNoticeProps {
  message: string;
}

const InvalidChartNotice = ({ message }: InvalidChartNoticeProps) => (
  <div
    role="img"
    aria-label={message}
    className="flex w-fit items-center gap-2 rounded-md border border-gray-300 bg-gray-50 px-3 py-4"
  >
    <Icons.Info className="size-5 shrink-0 text-gray-500" />
    <span className="text-base leading-6 text-gray-700">{message}</span>
  </div>
);

export default InvalidChartNotice;
